import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { isVue2 } from 'vue-demi';
/**
 * compatible merge attrs
 * @param props props
 * @param attrs attrs
 * @returns merged attrs
 */

export var mergeAttrs = function mergeAttrs(props, attrs) {
  var mergedAttrs = isVue2 ? {
    attrs: _objectSpread(_objectSpread({}, attrs), props)
  } : _objectSpread(_objectSpread({}, attrs), props);
  return mergedAttrs;
};